import { navigate } from 'gatsby'
import { Link } from 'gatsby-link'
import React, { FC, PropsWithChildren, useCallback } from 'react'
import { CustomAttributes } from '../types/CustomAttributes'

export interface AnchorLinkProps {
  className?: string
  customAttributes?: CustomAttributes
  /**
   * how many pixels to keep above the element after scrolling
   * to prevent it from ending up underneath sticky menus
   */
  offset?: number
  url: string
}

/**
 * Link component with support of creating anchor links.
 * Use this instead of 'gatsby-link' or regular a-tags as Gatsby breaks
 * them, by removing them once clicked.
 */
export const AnchorLink: FC<PropsWithChildren<AnchorLinkProps>> = ({
  children,
  className,
  customAttributes,
  url,
}) => {
  const onAnchorClick: React.MouseEventHandler<HTMLAnchorElement> = useCallback(
    async e => {
      e.preventDefault()
      e.nativeEvent.preventDefault()
      await navigate(url)
    },
    [url]
  )

  const isAnchor = url.startsWith('#')

  return isAnchor ? (
    <a className={className} href={url} onClick={onAnchorClick} {...customAttributes}>
      {children}
    </a>
  ) : (
    <Link className={className} to={url} {...customAttributes}>
      {children}
    </Link>
  )
}
